// eslint-disable-next-line import/no-anonymous-default-export
export default {
  clear() {
    localStorage.removeItem('IMP_TEMP_ID');
    localStorage.removeItem('IMP_TEMP_STEP');
    localStorage.removeItem('IMP_TEMP_FILE_NAME');
  },
  set ({id, filename, step}) {
    localStorage.setItem('IMP_TEMP_ID', id);
    localStorage.setItem('IMP_TEMP_STEP', step);
    localStorage.setItem('IMP_TEMP_FILE_NAME', filename);
  },
  getID () {
    return localStorage.getItem('IMP_TEMP_ID');
  },
  getFileName () {
    return localStorage.getItem('IMP_TEMP_FILE_NAME');
  },
  getStep () {
    return localStorage.getItem('IMP_TEMP_STEP');
  }
}